import { render, staticRenderFns } from "./NetaAttractionBasicDataComponent.vue?vue&type=template&id=d2740308&scoped=true&"
import script from "./NetaAttractionBasicDataComponent.vue?vue&type=script&lang=js&"
export * from "./NetaAttractionBasicDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaAttractionBasicDataComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NetaAttractionBasicDataComponent.vue?vue&type=style&index=1&id=d2740308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2740308",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2740308')) {
      api.createRecord('d2740308', component.options)
    } else {
      api.reload('d2740308', component.options)
    }
    module.hot.accept("./NetaAttractionBasicDataComponent.vue?vue&type=template&id=d2740308&scoped=true&", function () {
      api.rerender('d2740308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-attraction/basic-data/NetaAttractionBasicDataComponent.vue"
export default component.exports